module.exports = __webpack_public_path__ + "static/media/md-reverse-camera.5f7a5955.svg";